// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_db-a";
export var fulfillmentFormRail = "_db-9";
export var headerTitleRow = "_db-c";
export var orderDetailsWrapper = "_db-7";
export var orderLinkTrigger = "_db-2";
export var paymentInformationGrid = "_db-h";
export var paymentSummaryColumn = "_db-i";
export var shipmentContainer = "_db-b";
export var shipmentDetailsMainPane = "_db-8";
export var shipmentNavigationCard = "_db-5";
export var shipmentNavigationRail = "_db-3";
export var shipmentNavigationRailHeader = "_db-4";
export var shipmentSummaryFact = "_db-e";
export var shipmentSummaryGrid = "_db-d";
export var shipmentSummaryMetadataRow = "_db-f";
export var shipmentSummaryTags = "_db-g";
export var shipmentWorkspace = "_db-0";
export var shipmentWorkspaceContent = "_db-6";
export var shipmentWorkspaceHeader = "_db-1";